export default {
    production: true,
}